import React, { useMemo } from 'react';
import { useTable, usePagination, useSortBy, useFilters } from 'react-table';

const LoggingTable = ( { data } ) => {

  const columns = useMemo(
    () => [
      { Header: 'Version', accessor: 'Version' },
      { Header: 'Query', accessor: 'Query' },
      { Header: 'Time', accessor: 'Time' },
    ],
    []
  );

  const tableInstance = useTable({
  columns,
  data,
  initialState: { pageIndex: 0, sortBy:[{id: "Time", desc: true }]}},
  useFilters,
  useSortBy,
  usePagination,
);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = tableInstance;

  return (
    <>
      <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 mb-5 text-white font-bold tracking-wider uppercase text-md">Logging</h2>
      <div className="w-full overflow-x-scroll">
           <table {...getTableProps()} className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
             <thead>
               {headerGroups.map(headerGroup => (
                 <tr className="text-left" {...headerGroup.getHeaderGroupProps()}>
                   {headerGroup.headers.map(column => (
                     <th {...column.getHeaderProps()} className="sticky top-0 border-b border-b-4 border-gray-200 px-6 py-2 font-bold tracking-wider uppercase text-md">{column.render('Header')}
                         <span>
                           {column.isSorted
                             ? column.isSortedDesc
                               ? <i className="fas fa-chevron-down ml-1"></i>
                               : <i className="fas fa-chevron-up ml-1"></i>
                             : ''}
                         </span>
                     </th>
                   ))}
                 </tr>
               ))}
             </thead>
             <tbody {...getTableBodyProps()}>
               {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()} className="border-dashed border-t border-gray-200">
                              <span className="text-gray-800 px-6 py-2 flex items-center">
                                {cell.render('Cell')}
                              </span>
                        </td>
                      ))}
                    </tr>
                    )})}
             </tbody>
           </table>
        </div>
      <div className="pagination my-2 flex items-baseline">
        <div>
          <button onClick={() => previousPage()} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
            {'<'}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
            {'>'}
          </button>{' '}
          <span className="text-gray-800 px-6 py-1">
            Page{' '}
            <strong className="text-gray-800 px-6 py-1">
              {pageIndex + (pageOptions.length > 0)} of {pageOptions.length}
            </strong>{' '}
          </span>
        </div>
      </div>
    </>
  );
};

export default LoggingTable;

